module.exports = __webpack_public_path__ + "static/media/mission-text-animation.f9b35270.mp4";